var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 4C1.725 4 1.5 4.225 1.5 4.5V5.19063L6.89062 9.61563C7.5375 10.1469 8.46562 10.1469 9.1125 9.61563L14.5 5.19063V4.5C14.5 4.225 14.275 4 14 4H2ZM1.5 7.13125V12.5C1.5 12.775 1.725 13 2 13H14C14.275 13 14.5 12.775 14.5 12.5V7.13125L10.0625 10.775C8.8625 11.7594 7.13438 11.7594 5.9375 10.775L1.5 7.13125ZM0 4.5C0 3.39688 0.896875 2.5 2 2.5H14C15.1031 2.5 16 3.39688 16 4.5V12.5C16 13.6031 15.1031 14.5 14 14.5H2C0.896875 14.5 0 13.6031 0 12.5V4.5Z",
    fill: "#727190"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d58367b070369d167a0af0f8ad9ae0bf.svg";
export { ForwardRef as ReactComponent };